import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MediaService} from "../../services/media/media.service";
import {Media} from "../../models/media";
import {DatabaseService} from "../../services/database/database.service";
import {MessagesService} from "../../services/messages/messages.service";

@Component({
  selector: 'app-media-modal',
  templateUrl: './media-modal.component.html',
  styleUrls: ['./media-modal.component.scss']
})
export class MediaModal implements OnInit {
  @Input() media: Media[];
  @Input() projectId: String;

  mediaForm: FormGroup;
  mediaSelected: File;
  mediaType: string;
  mediaFormIsSubmitted: boolean = false;

  databaseLang: string = null;

  isLoading: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private mediaService: MediaService,
    private databaseService: DatabaseService,
    private messagesService: MessagesService,
  ) {
  }

  ngOnInit() {
    this.mediaForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      media: new FormArray([]),
      language: [''],
    });
  }

  onSelectedFile(event) {
    if (event.target.files.length) {
      this.mediaSelected = event.target.files[0];
      try {
        this.mediaType = this.mediaSelected['type'].split('/')[0];
      } catch (e) {
        this.mediaType = null;
      }
    }
  }

  submitMediaForm() {
    this.mediaFormIsSubmitted = true;

    if (this.mediaForm.invalid) {
      return;
    }

    if (!this.media.find(m => m.uri === this.mediaSelected.name))
      this.uploadFile();

    else {
      this.messagesService.overwriteMediaModal().result
        .then(
          result => {
            if (result) this.uploadFile();
          })
        .catch(() => {
        });
    }
  }

  uploadFile() {
    const formData: FormData = new FormData();
    formData.append('name', this.mediaForm.get('name').value);
    formData.append('media', this.mediaSelected, this.mediaSelected['name']);
    formData.append('type', this.mediaType);

    if (this.mediaForm.get('language').value)
      formData.append('language', this.mediaForm.get('language').value);

    this.isLoading = true;

    this.mediaService.postMedia(this.projectId, formData)
      .subscribe(
        () => this.messagesService.successToast('Media uploaded.'),
        err => this.messagesService.errorToast(err),
        () => {
          this.isLoading = false;
          this.activeModal.close(false)
        }
      );
  }

  onToggleLanguage(value: string) {
    this.mediaForm.patchValue({language: value ? null : this.databaseLang});
  }
}


